import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { getStats, getLinks } from '../services/api';
import { FaLink, FaHeart, FaChartLine, FaUser } from 'react-icons/fa';
import '../styles/Dashboard.css';

function Dashboard({ user }) {
  const [stats, setStats] = useState(null);
  const [recentLinks, setRecentLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [statsData, linksData] = await Promise.all([
        getStats(),
        getLinks({ limit: 5 })
      ]);
      setStats(statsData);
      setRecentLinks(linksData.links);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="app-layout">
        <Navbar user={user} />
        <main className="main-content">
          <div className="loading-container">
            <div className="spinner"></div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Navbar user={user} />
      <main className="main-content">
        <div className="page-header">
          <h1>Dashboard</h1>
          <p>Willkommen zurück, {user.username}!</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#5865F2' }}>
              <FaLink />
            </div>
            <div className="stat-content">
              <h3>{stats?.totalLinks || 0}</h3>
              <p>Total Links</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#EC4899' }}>
              <FaHeart />
            </div>
            <div className="stat-content">
              <h3>{stats?.novaLinks || 0}</h3>
              <p>Nova Links 💗</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#EF4444' }}>
              <FaHeart />
            </div>
            <div className="stat-content">
              <h3>{stats?.fayneLinks || 0}</h3>
              <p>Fayne Links ❤️</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: '#10B981' }}>
              <FaChartLine />
            </div>
            <div className="stat-content">
              <h3>{stats?.recentLinks?.reduce((sum, cat) => sum + cat.count, 0) || 0}</h3>
              <p>Links (Last 7 Days)</p>
            </div>
          </div>
        </div>

        <div className="dashboard-grid">
          <div className="dashboard-section">
            <h2>Recent Links</h2>
            <div className="recent-links">
              {recentLinks.length > 0 ? (
                recentLinks.map((link) => (
                  <div key={link.id} className="link-item">
                    <div className="link-category">
                      {link.category === 'nova' ? '💗' : '❤️'}
                    </div>
                    <div className="link-info">
                      <a href={link.url} target="_blank" rel="noopener noreferrer">
                        {link.url.length > 60 ? link.url.substring(0, 60) + '...' : link.url}
                      </a>
                      <p className="link-meta">
                        by {link.author_name} • {new Date(link.timestamp).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="no-data">No recent links</p>
              )}
            </div>
          </div>

          <div className="dashboard-section">
            <h2>Top Contributors</h2>
            <div className="top-authors">
              {stats?.topAuthors?.length > 0 ? (
                stats.topAuthors.slice(0, 5).map((author, index) => (
                  <div key={index} className="author-item">
                    <div className="author-rank">#{index + 1}</div>
                    <div className="author-info">
                      <FaUser />
                      <span>{author.author_name}</span>
                    </div>
                    <div className="author-count">{author.count} links</div>
                  </div>
                ))
              ) : (
                <p className="no-data">No data available</p>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
